module.exports = __webpack_public_path__ + "static/media/home-attachments.458bff44.jpg";